import React from "react";
import "./PersonaDeleteModal.css";
import { Button } from "../../ds2/components";

interface DeleteModalProps {
  onCancel: () => void;
  onDelete: () => void;
}

export const DeleteModal: React.FC<DeleteModalProps> = ({
  onCancel,
  onDelete,
}) => {
  return (
    <div
      className="persona-delete-modal-container"
      role="dialog"
      aria-modal="true"
      aria-labelledby="deleteModalTitle">
      <div className="persona-delete-modal-contentWrapper">
        <h2 id="deleteModalTitle" className="persona-delete-modal-title">
          You are about to delete this persona.
        </h2>
        <p className="persona-delete-modal-description">
          Are you sure you want to delete this persona? This action cannot be
          undone.
        </p>
      </div>
      <div className="persona-delete-modal-buttonContainer">
        <Button
          variant="secondary"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          onClick={onDelete}
          variant="primary"
          >
          Yes, delete
        </Button>
      </div>
    </div>
  );
};
